import { render, staticRenderFns } from "./InputValidation.vue?vue&type=template&id=5e4eddf5"
import script from "./InputValidation.vue?vue&type=script&lang=js"
export * from "./InputValidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports